// // PDP DRAWER CLOSE
// function closePantyDrawer(){
//     const pantyDrawerId = document.getElementById("calculatePantySizeDrawer");
//     const pantyOverlayId = document.getElementById("overlayCalculatePantySize");
//     pantyDrawerId.classList.remove("active");
//     pantyOverlayId.classList.remove("active");
//     document.body.classList.remove("drawer-open");
// }

// function closeBraDrawer(){
//     const pantyDrawerId = document.getElementById("calculateSizeDrawer");
//     const pantyOverlayId = document.getElementById("overlayCalculateSize");
//     pantyDrawerId.classList.remove("active");
//     pantyOverlayId.classList.remove("active");
//     document.body.classList.remove("drawer-open");
// }

// /* HANDLES MENU OPENING */
// document.addEventListener("DOMContentLoaded", () => {
//   const drawer = document.getElementById("Details-menu-drawer-container");
//   const scrollingBar = document.getElementById("scrolling-image-bar");

//   if (drawer) {
//     drawer.addEventListener("click", () => {
//       setTimeout(() => {
//         const isOpen = drawer.classList.contains("menu-opening");
//         scrollingBar.style.display = isOpen ? "none" : "block";
//       }, 50);
//     });
//   }
// });

// /* HANDLES MENU CLOSING */
// document.addEventListener("DOMContentLoaded", () => {
//   const crossBtn = document.querySelector(".header-logo-custom-cross");
//   const menuSummary = document.querySelector(
//     "#Details-menu-drawer-container summary.header__icon--menu"
//   );
//   const drawer = document.getElementById("Details-menu-drawer-container");

//   if (crossBtn && menuSummary) {
//     crossBtn.addEventListener("click", () => {
//       const open = menuSummary.getAttribute("aria-expanded") === "true";

//       if (open) {
//         menuSummary.setAttribute("aria-expanded", "false");
//         drawer.classList.remove("menu-opening");
//         document.body.classList.remove("overflow-hidden-tablet");
//         drawer.removeAttribute("open");
//       }
//     });
//   }
// });

// /* Generic accordion toggle */
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".js-custom-man-toggle").forEach((header) => {
//     header.addEventListener("click", (e) => {
//       e.stopPropagation();
//       const target = header.getAttribute("data-target");
//       const content = document.getElementById(target);

//       if (!content) return;

//       header.classList.toggle("is-active");
//       content.classList.toggle("is-active");
//     });
//   });
// });

// /* ———————————————————
//    GENERIC SWIPER INIT
// ———————————————————— */
// function initSwiper(selector, activeClass) {
//   const swiper = new Swiper(selector, {
//     slidesPerView: 7,
//     centeredSlides: true,
//     spaceBetween: 10,
//     loop: false,
//     slideToClickedSlide: true,
//     on: {
//       init(swiper) {
//         highlight(swiper);
//       },
//       slideChange(swiper) {
//         highlight(swiper);
//       },
//     },
//   });

//   function highlight(swiper) {
//     swiper.slides.forEach((sl) => sl.classList.remove(activeClass));
//     const active = swiper.slides[swiper.activeIndex];
//     if (active) active.classList.add(activeClass);
//   }

//   return swiper;
// }

// document.addEventListener("DOMContentLoaded", () => {
//   /* Bra measurement swipers */
//   const over = initSwiper(".over-burst-measurement", "over-burst-measurement__slide--active");
//   const under = initSwiper(".under-burst-measurement", "under-burst-measurement__slide--active");

//   const braSizeChart = [
//     { size: "S", underMin: 24, underMax: 27, overMin: 28, overMax: 31 },
//     { size: "M", underMin: 28, underMax: 30, overMin: 32, overMax: 35 },
//     { size: "L", underMin: 31, underMax: 32, overMin: 36, overMax: 39 },
//     { size: "XL", underMin: 33, underMax: 34, overMin: 40, overMax: 43 },
//     { size: "2XL", underMin: 35, underMax: 37, overMin: 44, overMax: 47 },
//     { size: "3XL", underMin: 38, underMax: 41, overMin: 48, overMax: 52 },
//   ];

//   const braDisplay = document.querySelector(".your-confirmed-size h3");

//   function calcBraSize() {
//     const u = parseFloat(under.slides[under.activeIndex]?.textContent || 0);
//     const o = parseFloat(over.slides[over.activeIndex]?.textContent || 0);

//     const match = braSizeChart.find(
//       (s) => u >= s.underMin && u <= s.underMax && o >= s.overMin && o <= s.overMax
//     );

//     if (braDisplay) braDisplay.textContent = match ? match.size : "...";
//   }

//   over.on("slideChange", calcBraSize);
//   under.on("slideChange", calcBraSize);

//   calcBraSize();
// });

// /* Panty measurement logic */
// document.addEventListener("DOMContentLoaded", () => {
//   const waist = initSwiper(".waist-measurement", "waist-measurement__slide--active");
//   const hip = initSwiper(".hip-measurement", "hip-measurement__slide--active");

//   const pantySizeChart = [
//     { size: "S", waistMin: 23, waistMax: 25, hipMin: 31, hipMax: 34 },
//     { size: "M", waistMin: 26, waistMax: 29, hipMin: 35, hipMax: 38 },
//     { size: "L", waistMin: 30, waistMax: 32, hipMin: 39, hipMax: 41 },
//     { size: "XL", waistMin: 33, waistMax: 35, hipMin: 42, hipMax: 45 },
//     { size: "2XL", waistMin: 36, waistMax: 39, hipMin: 46, hipMax: 49 },
//     { size: "3XL", waistMin: 40, waistMax: 43, hipMin: 50, hipMax: 54 },
//   ];

//   const pantyDisplay = document.querySelector(".your-panty-confirmed-size h3");

//   function calcPantySize() {
//     const w = parseFloat(waist.slides[waist.activeIndex]?.textContent || 0);
//     const h = parseFloat(hip.slides[hip.activeIndex]?.textContent || 0);

//     const match = pantySizeChart.find(
//       (s) => h >= s.hipMin && h <= s.hipMax && w >= s.waistMin && w <= s.waistMax
//     );

//     if (pantyDisplay) pantyDisplay.textContent = match ? match.size : "...";
//   }

//   waist.on("slideChange", calcPantySize);
//   hip.on("slideChange", calcPantySize);

//   calcPantySize();
// });

// /* Generic modal opener */
// document.addEventListener("DOMContentLoaded", () => {
//   const openBtn = document.getElementById("openSizeGuideDrawer");
//   const modal = document.getElementById("size-chart-modal");
//   const closeBtn = document.getElementById("size-chart-close");

//   if (!modal) return;

//   openBtn?.addEventListener("click", (e) => {
//     e.preventDefault();
//     modal.style.display = "flex";
//   });

//   closeBtn?.addEventListener("click", () => {
//     modal.style.display = "none";
//   });

//   window.addEventListener("click", (e) => {
//     if (e.target === modal) modal.style.display = "none";
//   });
// });

document.addEventListener("DOMContentLoaded", () => {

//   CLOSE DRAWER FUNCTION FOR PDP
  function closeDrawer(drawerId, overlayId) {
    const drawer = document.getElementById(drawerId);
    const overlay = document.getElementById(overlayId);
    window.enableVariantLock && window.enableVariantLock();
    drawer?.classList.remove("active");
    overlay?.classList.remove("active");
    document.body.classList.remove("drawer-open");
  }

  window.closePantyDrawer = () => closeDrawer("calculatePantySizeDrawer", "overlayCalculatePantySize");
  window.closeBraDrawer = () => closeDrawer("calculateSizeDrawer", "overlayCalculateSize");

// OPENING MENU
  const drawer = document.getElementById("Details-menu-drawer-container");
  const scrollingBar = document.getElementById("scrolling-image-bar");

  if (drawer) {
    drawer.addEventListener("click", () => {
      setTimeout(() => {
        const isOpen = drawer.classList.contains("menu-opening");
        if (scrollingBar) scrollingBar.style.display = isOpen ? "none" : "block";
      }, 50);
    });
  }

// CLOSE MENU THROUGH BTN
  const crossBtn = document.querySelector(".header-logo-custom-cross");
  const menuSummary = document.querySelector(
    "#Details-menu-drawer-container summary.header__icon--menu"
  );

  if (crossBtn && menuSummary && drawer) {
    crossBtn.addEventListener("click", () => {
      const open = menuSummary.getAttribute("aria-expanded") === "true";
      if (open) {
        menuSummary.setAttribute("aria-expanded", "false");
        drawer.classList.remove("menu-opening");
        document.body.classList.remove("overflow-hidden-tablet");
        drawer.removeAttribute("open");
      }
    });
  }

// INSIDE MENU ACCORDIONS
  document.querySelectorAll(".js-custom-man-toggle").forEach((header) => {
    header.addEventListener("click", (e) => {
      e.stopPropagation();
      const target = header.getAttribute("data-target");
      const content = document.getElementById(target);
      if (!content) return;
      header.classList.toggle("is-active");
      content.classList.toggle("is-active");
    });
  });

// INITIALIZING SWIPER
  function initSwiper(selector, activeClass) {
    const swiper = new Swiper(selector, {
      slidesPerView: 7,
      centeredSlides: true,
      spaceBetween: 10,
      loop: false,
      slideToClickedSlide: true,
      on: {
        init(swiper) {
          highlight(swiper);
        },
        slideChange(swiper) {
          highlight(swiper);
        },
      },
    });

    function highlight(swiper) {
      swiper.slides.forEach((sl) => sl.classList.remove(activeClass));
      const active = swiper.slides[swiper.activeIndex];
      active?.classList.add(activeClass);
    }

    return swiper;
  }


  // BRA MEASUREMENT SWIPERS + CALCULATION

  const over = initSwiper(".over-burst-measurement", "over-burst-measurement__slide--active");
  const under = initSwiper(".under-burst-measurement", "under-burst-measurement__slide--active");

  const braSizeChart = [
    { size: "S", underMin: 24, underMax: 27, overMin: 28, overMax: 31 },
    { size: "M", underMin: 28, underMax: 30, overMin: 32, overMax: 35 },
    { size: "L", underMin: 31, underMax: 32, overMin: 36, overMax: 39 },
    { size: "XL", underMin: 33, underMax: 34, overMin: 40, overMax: 43 },
    { size: "2XL", underMin: 35, underMax: 37, overMin: 44, overMax: 47 },
    { size: "3XL", underMin: 38, underMax: 41, overMin: 48, overMax: 52 },
  ];

  const braDisplay = document.querySelector(".your-confirmed-size h3");

  function calcBraSize() {
    const u = parseFloat(under.slides[under.activeIndex]?.textContent || 0);
    const o = parseFloat(over.slides[over.activeIndex]?.textContent || 0);

    const match = braSizeChart.find(
      (s) => u >= s.underMin && u <= s.underMax && o >= s.overMin && o <= s.overMax
    );

    if (braDisplay) braDisplay.textContent = match ? match.size : "...";
  }

  over.on("slideChange", calcBraSize);
  under.on("slideChange", calcBraSize);
  calcBraSize();


  // PANTY CALCULATOR

  const waist = initSwiper(".waist-measurement", "waist-measurement__slide--active");
  const hip = initSwiper(".hip-measurement", "hip-measurement__slide--active");

  const pantySizeChart = [
    { size: "S", waistMin: 23, waistMax: 25, hipMin: 31, hipMax: 34 },
    { size: "M", waistMin: 26, waistMax: 29, hipMin: 35, hipMax: 38 },
    { size: "L", waistMin: 30, waistMax: 32, hipMin: 39, hipMax: 41 },
    { size: "XL", waistMin: 33, waistMax: 35, hipMin: 42, hipMax: 45 },
    { size: "2XL", waistMin: 36, waistMax: 39, hipMin: 46, hipMax: 49 },
    { size: "3XL", waistMin: 40, waistMax: 43, hipMin: 50, hipMax: 54 },
  ];

  const pantyDisplay = document.querySelector(".your-panty-confirmed-size h3");

  function calcPantySize() {
    const w = parseFloat(waist.slides[waist.activeIndex]?.textContent || 0);
    const h = parseFloat(hip.slides[hip.activeIndex]?.textContent || 0);

    const match = pantySizeChart.find(
      (s) => h >= s.hipMin && h <= s.hipMax && w >= s.waistMin && w <= s.waistMax
    );

    if (pantyDisplay) pantyDisplay.textContent = match ? match.size : "...";
  }

  waist.on("slideChange", calcPantySize);
  hip.on("slideChange", calcPantySize);
  calcPantySize();


  // 8) GENERIC SIZE GUIDE MODAL

  const openBtn = document.getElementById("openSizeGuideDrawer");
  const modal = document.getElementById("size-chart-modal");
  const closeBtn = document.getElementById("size-chart-close");

  if (modal) {
    openBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      modal.style.display = "flex";
    });

    closeBtn?.addEventListener("click", () => (modal.style.display = "none"));

    window.addEventListener("click", (e) => {
      if (e.target === modal) modal.style.display = "none";
    });
  }
});

